export default __webpack_public_path__ + "static/media/sample-probono3.3a792ea0.png";